<!-- eslint-disable import/no-extraneous-dependencies -->
<template>
  <div class="comment-panel full-height" style="width:720px">
   <div class="centerblockimg" v-if="!totalComments || totalComments.length === 0">
      <svgicon name="NoComments" width="100px" height="190px" :original="true"/>
      <div>{{ $t('INDENTS_NO_COMMENTS_FOUND') }}</div>
    </div>
    <div class="comment-body is-editable" v-else>
      <div v-for="(commentObj, index) in totalComments" :key="'comment-'+ index">
        <div class="comment-date">
          <span>
            {{ commentObj.date | moment('DD MMM YYYY') }}
          </span>
        </div>
        <div v-for="(comment, commentIndex) in commentObj.comments"
          :key="'commentitem-' + commentIndex">
          <h6 class="comment-title">
            <span class="badge bg-orange-light" v-if="comment.user.type ===1 ">{{'S'}}</span>
            <span class="badge bg-orange-light" v-else>{{'T'}}</span>
            <span>{{ comment.user.name }}</span>
            <small class="ml-auto">{{ getDate(comment.create_at) }}</small>
          </h6>
          <span class="comment-tag f-left" v-if="comment.tag_name">{{comment.tag_name}}</span>
          <p class="comment-box" v-html="comment.message.replace(/\n/g, '<br>')"></p>
          <span class="comment-attachment" v-if="comment.attachment_flag">
          <i class="mr-5">
            <a :href = "comment.attachment.metadata.location">
            <svgicon
              :name="setIcon(comment.attachment.content_file_name)"
              width="12"
              height="12"
              :original="true"
            />&nbsp;{{comment.attachment.content_file_name}}</a>
          </i>
        </span>
        </div>
      </div>
    </div>
    <div class="comment-bottom">
      <div contenteditable="true"
        placeholder="Add Comment"
        class="content-editable"
        id="comments-input"
        @input="updateHTML"
      >
      </div>
      <span class="comment-dropdown" contenteditable="false">
          <Select
            v-model="tagName"
            placeholder="Add Tag"
            size="mini"
            class="select-default no-bg">
            <Option
              v-for="item in getTagOption"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </Option>
          </Select>
        </span>
      <div class="comment-action">
        <Upload
        ref="attachmentUpload"
          action
          :on-change="handleChange"
          :auto-upload="false"
          :limit="1"
          class="default-upload upload-plain upload-file no-bg"
          id="comments-attachment"
        >
          <svgicon
            name="icon-attachment-sm"
            class="text-blue-darker pointer"
            width="8"
            height="12"
          />
        </Upload>
        <div class="ml-auto">
          <Button
            type="text"
            size="mini"
            class="button-link secondary ml-10"
            @click="clearMessage()"
            >{{ $t('CANCEL') }}</Button>
          <Button
            type="text"
            size="mini"
            class="button-link"
            @click="add()"
            >{{ $t('ADD') }}</Button>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import moment from 'moment';
import Attachments from '@common/components/Attachments';
import AttachmentConstants from '@common/constants/AttachmentConstants';
import { conversationSection, movementType as movementListType } from 'pando-constants';

export default {
  props: {
    indent: {
      type: Object,
      default: () => {},
    },
    formatTime: {
      type: String,
      default: 'hh:mm A',
    },
    configurations: {
      type: Object,
    },
  },
  components: {
    Attachments,
  },

  data() {
    return {
      activeName: null,
      message: '',
      totalComments: [],
      tempAttachments: null,
      movementListType,
      tagName: '',
    };
  },
  computed: {
    getTagOption() {
      let option = [];
      if (this.indent.movement === this.movementListType.RETURNS) {
        option = (this.configurations.chat &&
          this.configurations.chat.movement_based &&
          this.configurations.chat.movement_based.return) || [];
      } else if (this.indent.movement === this.movementListType.INWARD) {
        option = (this.configurations.chat &&
          this.configurations.chat.movement_based &&
          this.configurations.chat.movement_based.inward) || [];
      } else if (this.indent.movement === this.movementListType.PRIMARY) {
        option = (this.configurations.chat && this.configurations.chat.movement_based &&
          this.configurations.chat.movement_based.primary) || [];
      } else {
        option = (this.configurations.chat && this.configurations.chat.movement_based &&
          this.configurations.chat.movement_based.secondary) || [];
      }
      return option && option.map(value => ({
        label: value,
        value,
      }));
    },
  },
  methods: {
    handleChange(file, fileList) {
      const isSizeExceed = file.size / 1024 / 1024 < AttachmentConstants.maxMbSize;
      const fileExt = this.findFileExt(file);
      const isFileFormat = AttachmentConstants.images.includes(fileExt) ||
        AttachmentConstants.pdf.includes(fileExt) ||
        AttachmentConstants.excel.includes(fileExt) ||
        AttachmentConstants.images.includes(fileExt);
      if (!isSizeExceed) {
        this.$errorMessage({ message: this.$getErr('FILE_SIZE_EXCEED') });
        fileList.pop();
      } else if (!isFileFormat) {
        this.$errorMessage({ message: this.$getErr('INVALID_FORMAT') });
        fileList.pop();
      } else {
        this.tempAttachments = file;
      }
    },
    setIcon(file) {
      const fileExt = this.findFileExt(file);
      if (AttachmentConstants.images.includes(fileExt)) {
        return 'imggallery';
      } else if (AttachmentConstants.pdf.includes(fileExt)) {
        return 'icon-pdf';
      } else if (AttachmentConstants.excel.includes(fileExt)) {
        return 'excel';
      }
      return 'download-icon';
    },
    findFileExt(file) {
      if (file.name) {
        const fileName = file.name;
        // eslint-disable-next-line no-bitwise
        return fileName.slice(((fileName.lastIndexOf('.') - 1) >>> 0) + 2).toLowerCase();
      }
      const fileName = file.url ? file.url : file;
      // eslint-disable-next-line no-bitwise
      const index1 = ((fileName.lastIndexOf('.') - 1) >>> 0) + 2;
      let index2 = fileName.indexOf('?');
      index2 = index2 === -1 ? fileName.length : index2;
      return fileName.slice(index1, index2).toLowerCase();
    },
    async storeAttachment(file, commentId) {
      const formData = new FormData();
      formData.append('attachment', file.raw);
      formData.append('attachable_id', commentId);
      formData.append('attachable_type', 1);

      const result  = await this.$store.dispatch('indents/addCommentAttachment',
        { formData });
      if (result && result.error) {
        this.$error({ message: result.error || this.$getErr('UPLOAD_FAILS') });
      }
    },
    clearMessage() {
      this.message = '';
      this.tagName = '';
      this.clearAttachment();
      document.getElementById('comments-input').innerText = '';
    },
    clearAttachment() {
      this.tempAttachments = null;
      this.$refs.attachmentUpload.clearFiles();
    },
    clearFiles() {
      this.tempAttachments = [];
    },
    updateHTML(e) {
      this.message = e.target.innerText;
    },
    async add() {
      if (this.message) {
        const orderNo = this.indent.order_no;
        const commentData = {
          comment: this.message,
          attachment_flag: false,
        };
        if (this.tempAttachments) {
          commentData.attachment_flag = true;
        }
        if (this.tagName !== '' || null) {
          commentData.tag_name = this.tagName;
        }
        const result = await this.$store.dispatch('indents/addComment', { orderNo, commentData });
        if (this.tempAttachments) {
          // eslint-disable-next-line no-underscore-dangle
          await this.storeAttachment(this.tempAttachments, result[result.length - 1]._id);
          // eslint-disable-next-line no-underscore-dangle
          await this.getAttachment(result[result.length - 1]._id);
        }
        this.clearMessage();
        this.clearAttachment();
        await this.getComments();
      } else {
        this.$error({ message: this.$getErr('NO_COMMENT_ENTERED') });
      }
    },
    async getComments() {
      const comments = {};
      const res = await this.$store.dispatch('indents/getComments',
        { orderNo: this.indent.order_no, sectionNo: conversationSection.INDENT_COMMENT });
      let indentComment = null;
      if (res && res.comments) {
        indentComment = await Promise.all(
          res.comments.map(
            async (comment) => {
              if (comment.attachment_flag) {
                comment.attachment = await this.getAttachment(comment._id);
              }
              return comment;
            }),
        );
      }
      if (indentComment) {
        indentComment.forEach((comment) => {
          const date = comment.create_at.slice(0, 10);
          if (comments[date]) {
            comments[date].push(comment);
          } else {
            comments[date] = [comment];
          }
        });
      }
      this.totalComments = [];
      const dates = Object.keys(comments);
      dates.forEach((date) => {
        this.totalComments.push({
          date,
          comments: comments[date],
        });
      });
    },
    async getAttachment(commentId) {
      const result = await this.$store.dispatch('indents/getCommentAttachments',
        { attachable_id: commentId });
      return result;
    },
    getDate(date) {
      return moment(date).format(this.formatTime);
    },
  },
  async mounted() {
    await this.getComments();
  },
};
</script>
<style scoped>
.comment-box {
  background-color: #f8f9fa;
  padding: 10px;
  border-radius: 5px;
  font-family: Arial, sans-serif;
  white-space: pre-line;
}
</style>
